import { render } from "./DegreeSelect.vue?vue&type=template&id=755993bc&scoped=true"
import script from "./DegreeSelect.vue?vue&type=script&lang=js"
export * from "./DegreeSelect.vue?vue&type=script&lang=js"

import "./DegreeSelect.vue?vue&type=style&index=0&id=755993bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755993bc"]])

export default __exports__